import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestRoutingModule } from './test-routing.module';
import { JBMViewModule} from "../components/JBM/Views/jbmview.module";
import { TestComponent} from "./test/test.component";

@NgModule({
  declarations: [TestComponent],
  imports: [
    CommonModule,
    TestRoutingModule,
    JBMViewModule
  ]
})
export class TestModule { }
